import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import { LoadingSkeleton } from "@kunduz/ui";
import { IContent } from "@kunduz/data-access-cms-api";
import styles from "./desktopRightLoader.module.scss";

const DesktopLazyLoadedRight = dynamic<any>(
  () => {
    return import("./desktopRight").then((module) => module.DesktopRight);
  },
  {
    ssr: false,
    loading: () => (
      <div style={{ display: "flex", gap: 12 }}>
        <LoadingSkeleton className={styles.loader} />
        <LoadingSkeleton style={{ width: 150, height: 44 }} />
      </div>
    ),
  },
);

export const DesktopRightLoader = (props: {
  headerType: "student" | "teacher" | "school";
  desktopRightCmsData?: IContent.HeaderItemsResponse["components"];
}): ReactElement => {
  return <DesktopLazyLoadedRight {...props} />;
};
